import types from './types';

const resetDetails = () => ({
  type: types.RESET_DETAILS
});

const toggleValidationMessage = () => ({
  type: types.TOGGLE_VALIDATION_MESSAGE
});

const addValidationMessageToast = errorsCounter => ({
  type: types.ADD_VALIDATION_MESSAGE_TOAST,
  params: { errorsCounter }
});

export default {
  resetDetails,
  toggleValidationMessage,
  addValidationMessageToast
};
